import React from "react";

/**
 * Minimal, XSS-safe markdown renderer for assistant replies.
 * Handles **bold**, numbered lists (`1. `), bullet lists (`- ` / `* `) and
 * blank-line spacing. Builds React nodes only — no dangerouslySetInnerHTML.
 */
const renderInline = (text, keyPrefix) => {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) {
      return <strong key={`${keyPrefix}-b-${i}`}>{part.slice(2, -2)}</strong>;
    }
    return (
      <React.Fragment key={`${keyPrefix}-t-${i}`}>{part}</React.Fragment>
    );
  });
};

const FormattedMessage = ({ content }) => {
  const lines = String(content || "").split("\n");

  return (
    <div className="ai-md">
      {lines.map((raw, idx) => {
        const line = raw.replace(/\s+$/, "");
        if (!line.trim()) return <div key={idx} className="ai-md-gap" />;

        const numbered = line.match(/^\s*(\d+)\.\s+(.*)$/);
        if (numbered) {
          return (
            <div key={idx} className="ai-md-li">
              <span className="ai-md-marker">{numbered[1]}.</span>
              <span>{renderInline(numbered[2], idx)}</span>
            </div>
          );
        }

        const bullet = line.match(/^\s*[-*]\s+(.*)$/);
        if (bullet) {
          return (
            <div key={idx} className="ai-md-li">
              <span className="ai-md-marker">•</span>
              <span>{renderInline(bullet[1], idx)}</span>
            </div>
          );
        }

        // Indented continuation lines (sub-fields under a numbered task).
        const indented = /^\s{2,}\S/.test(raw);
        return (
          <div
            key={idx}
            className={`ai-md-p ${indented ? "ai-md-indent" : ""}`}
          >
            {renderInline(line, idx)}
          </div>
        );
      })}
    </div>
  );
};

export default FormattedMessage;
